<template>
  <v-text-field
    @input="preventSpecialChars($event)"
    @focus="clearAmount"
    @blur="resetAmount"
    v-model="value"
    :rules="[rules.minAmount, rules.maxAmount]"
    :prefix="percent ? '' : $t('currency.symbol')"
    :class="`${fullWidth ? '' : 'mw-200'}`"
    :suffix="percent ? '%' : ',00'"
    :error-message="errorMessage"
    :disabled="disabled"
    :error="hasError"
    :label="label"
    class="amount inputAmount"
    hide-details="auto"
    placeholder="0"
    maxlength="6"
    type="number"
    outlined
  />
</template>

<script>
export default {
  name: 'HAmount',

  props: {
    label: {
      type: String,
    },

    minAmount: {
      type: Number,
      default: 1,
    },

    maxAmount: {
      type: Number,
      default: 100000,
    },

    amount: {
      type: [String, Number],
      default: '0',
    },

    percent: {
      type: Boolean,
      default: false,
    },

    fullWidth: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    hasError: {
      type: Boolean,
      default: false,
    },

    errorMessage: {
      type: String,
      default: '',
    },
  },

  watch: {
    amount(value) {
      this.value = value
    },
  },

  data() {
    return {
      value: this.amount ? this.amount : 0,

      rules: {
        minAmount: (value) => {
          if (value != '') {
            return (
              parseInt(value) >= this.minAmount ||
              this.$t('rules.minAmount', { value: this.minAmount })
            )
          }

          return true
        },

        maxAmount: (value) => {
          if (value > this.maxAmount && value != '') {
            return (
              parseInt(value) < this.maxAmount ||
              this.$t('rules.maxAmount', { value: this.maxAmount })
            )
          }

          return true
        },
      },
    }
  },

  methods: {
    preventSpecialChars(event) {
      const { keyCode, target } = window.event

      if (
        target.value !== '0' &&
        /^0+/gi.test(target.value) &&
        keyCode > 31 &&
        (keyCode < 48 || keyCode > 57) &&
        keyCode != 37 &&
        keyCode != 39
      ) {
        event.preventDefault()
      } else {
        this.$emit('input', target.value)
      }
    },

    clearAmount() {
      if (this.value < 1) {
        this.value = ''
      }
    },

    resetAmount() {
      if (this.value === '' || this.value === undefined) {
        this.value = '0'
      }
    },

    hardResetAmount() {
      this.value = '0'
    },
  },
}
</script>

<style>
/* Classes to remove arrows from type number input */

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
